<template>
  <div
    id="app"
    class="relative font-sans text-base leading-normal overflow-hidden"
  >
    <div class="md:flex hidden flex-col w-full h-screen bg-white">
      <div
        class="relative w-full flex-1"
        :class="[$store.state.openCodeSandbox ? 'hidden' : 'flex']"
      >
        <div class="absolute pin flex">
          <div class="w-2/5">
            <VuePerfectScrollbar class="h-full">
              <div class="flex flex-col min-h-full py-24 px-40">
                <div class="flex justify-between mb-40">
                  <h1>
                    <a
                      href="https://www.algolia.com/doc"
                      aria-label="Algolia Docs"
                    >
                      <logo-docs class="block h-48 -mt-8" />
                      <span class="sr-only">
                        Algolia Docs Interactive Tutorial
                      </span>
                    </a>
                  </h1>
                  <p v-show="!$store.getters.isUserLoggedIn">
                    <a
                      class="text-link"
                      href="https://www.algolia.com/users/sign_up"
                      target="_blank"
                      @click="
                        track({
                          message: 'Clicked Sign Up',
                          code: 'docs.onboarding.signup',
                          extraData: {
                            source: 'Permanent'
                          }
                        })
                      "
                      >Sign up</a
                    >
                    or
                    <a
                      class="text-link"
                      href="https://www.algolia.com/users/sign_in"
                      target="_blank"
                      @click="
                        track({
                          message: 'Clicked Login',
                          code: 'docs.onboarding.signin'
                        })
                      "
                      >Log in</a
                    >
                  </p>
                </div>
                <router-view
                  class="flex flex-col flex-1 justify-between min-h-full text-shuttle-grey"
                />
              </div>
            </VuePerfectScrollbar>
          </div>
          <router-view
            name="editor"
            class="w-3/5 h-full flex flex-col bg-martinique"
          />
        </div>
      </div>
      <router-view name="codesandbox" class="flex-1" />
      <footer-navigation
        :current-step="getCurrentStep"
        class="flex-no-shrink z-40"
      />
    </div>
    <mobile-fallback
      class="md:hidden flex w-full h-screen flex-col justify-center items-center"
    />
    <div class="hidden">{{ getEventString }}</div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import getLoggedInUser from '@/scripts/GetLoggedInUser'
import injectCookieConsent from '@/scripts/InjectCookieConsent'
import { googleTagManager, pingdom, segment } from '@/scripts/TrackingScripts'
import track from '@/scripts/Track'

import LogoDocs from '@/assets/images/logo-docs.svg'
import MobileFallback from '@/partials/MobileFallback'
import FooterNavigation from '@/partials/FooterNavigation'

export default {
  components: {
    LogoDocs,
    VuePerfectScrollbar,
    MobileFallback,
    FooterNavigation
  },
  computed: {
    getCurrentStep() {
      return parseInt(this.$route.name, 10) || 1
    },
    getEventString() {
      return `${this.$store.getters.getPickDatasetsDataset.id}-${this.$store.getters.getPushDataDataset.id}-${this.$store.getters.getUiLibrary.id}`
    }
  },
  methods: {
    injectThirdPartyScripts() {
      if (process.env.NODE_ENV === 'production') injectCookieConsent()
      googleTagManager(process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID)
      pingdom()
      segment(process.env.VUE_APP_SEGMENT_ID)
    },
    injectGlobalVariables() {
      window.KISSMETRICS_KEY = process.env.VUE_APP_KISSMETRICS_KEY
      window.ALGOLIA_HOST = process.env.VUE_APP_ALGOLIA_HOST
    },
    track
  },
  mounted() {
    this.injectGlobalVariables()
    this.injectThirdPartyScripts()
    this.$nextTick(() => {
      getLoggedInUser(process.env.VUE_APP_ALGOLIA_HOST).then(response => {
        if (response.user_id) {
          this.$store.commit('setUserData', {
            userId: response.user_id,
            applicationId: response.application_id,
            writeApiKey: response.write_api_key,
            searchApiKey: response.search_api_key
          })
        }
        window.analytics.identify(response.user_id)
      })
    })
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700');
@import './src/assets/css/styles';

.ps__scrollbar {
  &-x {
    bottom: 0 !important;
    height: 8px !important;
    &-rail {
      height: 16px !important;
    }
  }
  &-y {
    right: 0 !important;
    width: 8px !important;
    &-rail {
      width: 16px !important;
    }
  }
  &-x,
  &-y {
    background: #c5c9e0 !important;
    &-rail {
      background: none !important;
      margin: 4px;
    }
  }
}
</style>
